// Toggle interactivity - use jQuery SlideToggle if needed
(function($){
	$(".wp-block-baytek-toggle:not(.grid-groups) .toggle-header").on( "click", function() {
		$(this).next().slideToggle("300", function() {
			$(this).parent().toggleClass("expanded");
		});
	});

	$(".wp-block-baytek-toggle.grid-groups .toggle-header").on( "click", function() {
		$(this).next().slideToggle("300", function() {
			$(this).parent().toggleClass("expanded-grid");
		});
	});

})(jQuery);

